import queryString from 'query-string'

function getQueryParamsFromHash(): queryString.ParsedQuery<string> {
  const [, query = ''] = window.location.hash.split('?')
  return queryString.parse(query)
}

export default getQueryParamsFromHash
